import { date } from 'quasar'

const DEFAULT_CONTEXT = {
  hasAgeRestrictions: false,
  minimumAge: 0
}

export function useShouldDisableContactFields () {
  function disableContactFields (user, context = DEFAULT_CONTEXT) {
    const siteHasAgeRestrictions = context.hasAgeRestrictions && _.isInteger(context.minimumAge)

    if (!siteHasAgeRestrictions) {
      return false
    }

    const userHasAge = !!user.dateOfBirth
    const userAge = getUserAge(user)
    const minimumAge = context.minimumAge
    const userIsAtLeastMinimumAge = !userHasAge || userAge >= minimumAge

    const userHasClass = !!user.userClass
    const userClassMeetsAgeRequirement = !userHasClass || checkUserClassMeetsAgeRequirement(user.userClass, minimumAge)

    return !userIsAtLeastMinimumAge || !userClassMeetsAgeRequirement
  }

  function getUserAge (user) {
    if (!user.dateOfBirth) {
      return null
    }
    const birthdate = date.extractDate(user.dateOfBirth, 'YYYY-MM-DD')
    const today = new Date()
    return date.getDateDiff(today, birthdate, 'years')
  }

  function checkUserClassMeetsAgeRequirement (userClass, minimumAge) {
    if (!userClass.minAge && !userClass.maxAge) {
      return true
    }
    if (userClass.minAge && userClass.minAge >= minimumAge) {
      return true
    }
    if (userClass.maxAge && userClass.maxAge < minimumAge) {
      return false
    }
    return true
  }

  return {
    disableContactFields
  }
}
